import '../../Common.scss';
import { Loader } from '@trackman/web-shared-components';
import Subtitle from 'components/TextComps/Subtitle';
import { InviteStudents } from 'pages/Organization/components/Invites/InviteStudents/InviteStudents';
import { UploadStudentList } from 'pages/Organization/components/Invites/UploadStudentList/UploadStudentList';
import NoClassesFound from 'pages/Organization/components/NoClassesFound/NoClassesFound';
import { SelectClass } from 'pages/Organization/components/SelectClass/SelectClass';
import { NoStudentsFound } from 'pages/Organization/components/Students/NoStudentsFound/NoStudentsFound';
import { StudentsAndInvites } from 'pages/Organization/components/StudentsAndInvites/StudentsAndInvites';
import { StudentsSearchInput } from 'pages/Organization/components/StudentsSearch/StudentsSearch';
import { useGetClasses } from 'queryHooks/Organization/Classes/useGetClasses';
import { useGetInvites } from 'queryHooks/Organization/Invites/useGetInvites';
import { useGetStudents } from 'queryHooks/Organization/Students/useGetStudents';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';
import { useStudentsStore } from 'stores/Organization/StudentsStore';
import { Class } from 'types/organization/classes';
import { Invite } from 'types/organization/invites';
import { Student } from 'types/organization/students';

export const StudentsTab = () => {
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);
  const selectedClassId = useStudentsStore((state) => state.selectedClassId);
  const setSelectedClassId = useStudentsStore((state) => state.setSelectedClassId);
  const { data: studentList, isPending: isStudentListPending } = useGetStudents(selectedOrganizationId);
  const { data: inviteList, isPending: isInviteListPending } = useGetInvites(selectedOrganizationId);
  const { data: classList, isPending: isClassListPending } = useGetClasses(selectedOrganizationId, false, (selectedClassId) =>
    setSelectedClassId(selectedClassId)
  );

  return (
    <>
      {!isStudentListPending && !isInviteListPending && !isClassListPending ? (
        <StudentsTabContent
          classList={classList}
          studentList={studentList}
          inviteList={inviteList}
          selectedClassId={selectedClassId}
          setSelectedClassId={setSelectedClassId}
        />
      ) : (
        <div className='new-loader-wrapper'>
          <Loader size='large' />
        </div>
      )}
    </>
  );
};

type Props = {
  classList: Class[] | undefined;
  studentList: Student[] | undefined;
  inviteList: Invite[] | undefined;
  selectedClassId: string;
  setSelectedClassId: (classId: string) => void;
};
const StudentsTabContent = ({ classList, studentList, inviteList, selectedClassId, setSelectedClassId }: Props) => {
  const { t } = useTranslation();

  const [filter, setFilter] = useState<string>('');

  const isInviteStudentsModalOpen = useOrganizationStore((state) => state.isInviteStudentsModalOpen);
  const isImportStudentListModalOpen = useOrganizationStore((state) => state.isImportStudentListModalOpen);
  const setIsInviteStudentsModalOpen = useOrganizationStore((state) => state.setIsInviteStudentsModalOpen);
  const setIsImportStudentListModalOpen = useOrganizationStore((state) => state.setIsImportStudentListModalOpen);

  return (
    <>
      {!classList || classList.length === 0 ? (
        <NoClassesFound />
      ) : (!studentList || studentList.length === 0) && (!inviteList || inviteList.length === 0) ? (
        <NoStudentsFound />
      ) : (
        <>
          <div className='tab-searchbar-section'>
            <Subtitle>{t('StudentAndClassProgress', { ns: 'organizationPage' })}</Subtitle>
            <div className='filters'>
              <SelectClass onChange={setSelectedClassId} value={selectedClassId} classesList={classList} />
              <StudentsSearchInput label={t('SearchForStudentsAndInvites', { ns: 'studentsPage' })} value={filter} onChange={setFilter} />
            </div>
          </div>

          <div className='organization-tab-content'>
            <StudentsAndInvites filter={filter} setFilter={setFilter} />
          </div>
        </>
      )}
      {isInviteStudentsModalOpen && <InviteStudents isOpen={isInviteStudentsModalOpen} close={() => setIsInviteStudentsModalOpen(false)} />}
      {isImportStudentListModalOpen && (
        <UploadStudentList isOpen={isImportStudentListModalOpen} close={() => setIsImportStudentListModalOpen(false)} />
      )}
    </>
  );
};
